function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  cx: 50.016,
  cy: 50.252,
  r: 47.909
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  d: "M90.017,50.252c0,22.088-17.913,40.001-40,40.001 c-22.091,0-40-17.913-40-40.001s17.909-40,40-40C72.104,10.252,90.017,28.164,90.017,50.252z"
});

var SvgCameraCapture = function SvgCameraCapture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCameraCapture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera_capture.a949facb.svg";
export { ForwardRef as ReactComponent };